import client from './client';

export const surveyTemplatesApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/survey-templates', { params });
    return data;
  },

  async get(id) {
    const { data } = await client.get(`/api/survey-templates/${id}`);
    return data;
  },

  async create(body) {
    const { data } = await client.post('/api/survey-templates', body);
    return data;
  },

  async update(id, body) {
    const { data } = await client.patch(`/api/survey-templates/${id}`, body);
    return data;
  },

  async archive(id) {
    const { data } = await client.post(`/api/survey-templates/${id}/archive`);
    return data;
  },

  async unarchive(id) {
    const { data } = await client.post(`/api/survey-templates/${id}/unarchive`);
    return data;
  },

  async remove(id) {
    await client.delete(`/api/survey-templates/${id}`);
  },
};
